import React from "react";

export default class SuccessMsg extends React.Component {
  render() {
    return (
      <section className="success-msg">
        <p>item added to cart!</p>
      </section>
    );
  }
}
